import { cn } from '@simplywallst/ui-core/next';
import { Tooltip } from '../Tooltip';

import { formatterCurrency, formatterPercentage } from '@/utilities/format';

import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

type Props = Pick<
  PortfolioDetailedReturns['detailedReturns'],
  | 'annualisedReturn'
  | 'costBasis'
  | 'currencyGains'
  | 'dividends'
  | 'realizedGains'
  | 'totalGains'
  | 'unrealizedGains'
  | 'value'
> & {
  notTransactionalPortfolio: boolean;
};

export const Total = ({
  value,
  costBasis,
  unrealizedGains,
  realizedGains,
  dividends,
  currencyGains,
  totalGains,
  annualisedReturn,
  notTransactionalPortfolio,
}: Props) => {
  const cell = cn(
    'border-b border-l-0 border-r border-t-2 border-solid border-soft p-x2 text-xs font-strong text-solid'
  );
  return (
    <tr
      aria-label="Overview Total"
      className="[&_td:nth-child(1)]:text-left [&_td:nth-child(10)]:bg-brand-01-softer [&_td:nth-child(n+6):nth-child(-n+9)]:bg-brand-01-subtle [&_td]:text-right"
    >
      <td className={cell}>
        <span className="uppercase">Total</span>
      </td>
      <td className={cell} />
      <td className={cell} />
      <td className={cell}>{formatterCurrency(value, 'XXX')}</td>
      <td className={cell}>{formatterCurrency(costBasis, 'XXX')}</td>
      <td className={cell}>{formatterCurrency(unrealizedGains, 'XXX')}</td>
      {notTransactionalPortfolio ? (
        <>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
          <td className={cell}>{formatterCurrency(totalGains, 'XXX')}</td>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
        </>
      ) : (
        <>
          <td className={cell}>{formatterCurrency(realizedGains, 'XXX')}</td>
          <td className={cell}>{formatterCurrency(dividends, 'XXX')}</td>
          <td className={cell}>{formatterCurrency(currencyGains, 'XXX')}</td>
          <td className={cell}>{formatterCurrency(totalGains, 'XXX')}</td>
          <td className={cell}>
            {annualisedReturn ? (
              formatterPercentage(annualisedReturn)
            ) : (
              <Tooltip
                label="No data"
                tip="To calculate IRR, the position must be held for at least 90 days, and the selected period must also be 90 days or more."
              />
            )}
          </td>
        </>
      )}
    </tr>
  );
};
